var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { Microservices } from 'services/microservices/microservices';
export const useDateTime = () => {
    const microservices = new Microservices();
    const [startDateTime, setStartDateTime] = React.useState();
    const [currentDateTime, setCurrentDateTime] = React.useState();
    const [secondInterval, setSecondInterval] = React.useState();
    React.useEffect(() => {
        const getDateTime = () => __awaiter(void 0, void 0, void 0, function* () {
            const serviceDateTime = yield microservices.getDateTime();
            setStartDateTime(serviceDateTime);
            setCurrentDateTime(serviceDateTime);
        });
        getDateTime();
    }, []);
    React.useEffect(() => {
        if (!currentDateTime) {
            return;
        }
        const interval = setInterval(() => {
            const dt = currentDateTime.setSeconds(currentDateTime.getSeconds() + 1);
            setCurrentDateTime(new Date(dt));
        }, 1000);
        setSecondInterval(interval);
        return () => {
            clearInterval(interval);
        };
    }, [startDateTime]);
    const stopInterval = () => {
        if (secondInterval) {
            clearInterval(secondInterval);
        }
    };
    return { currentDateTime, stopInterval };
};
export default useDateTime;
